import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
import { SENDER_EMAIL_VALID_LIST } from '../api';
export const useSenderEmailValidList = () => {
  const $ = _c(4);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t0);
  const {
    data
  } = useSWR(user && SENDER_EMAIL_VALID_LIST, fetcher);
  let t1;
  if ($[1] !== data || $[2] !== isFetching) {
    t1 = {
      data,
      isFetching
    };
    $[1] = data;
    $[2] = isFetching;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};